export function TMSInstitution() {
  return (
    <section data-testid="tms-institution-section" className="max-w-[1100px] mx-auto px-6 md:px-12 py-20 md:py-28">
      <p className="text-xs uppercase tracking-[0.3em] text-[#5e1420] mb-5">The Institution</p>
      <h2 className="font-display text-2xl md:text-4xl font-medium leading-snug max-w-3xl">
        Most training tells you what to do. The Muscle School teaches you why your body was built to need it.
      </h2>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8 text-textSecondary text-base leading-[1.7]">
        <p>
          The Muscle School is a structured curriculum, not a workout program. It reconstructs the full
          chain of evidence — from the evolutionary physics that made muscle necessary, to the cellular
          machinery that builds it, to what happens to the human body in the absence of the demands it
          evolved to expect.
        </p>
        <p>
          Every lesson follows the same reasoning model: Environment → Stress → Adaptation → Capability →
          Expansion. It is built to be read once and referenced for a lifetime — by anyone who wants to
          understand their own biology well enough to direct it, rather than guess at it.
        </p>
      </div>
    </section>
  );
}
